
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");


var $9wGTI = parcelRequire("9wGTI");

/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen); // Dialogs may not be needed anymore for live pages - this is a fix for a Forge issue where this is causing re-renders and app is losing context
    // See: https://atlassian.slack.com/archives/CFHD7ERB4/p1755775542436799?thread_ts=1754500884.539789&cid=CFHD7ERB4
    const dialogsProp = (0, $9wGTI.fg)('confluence_skip_dialogs_prop') ? undefined : dialogs;
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogsProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                ...(0, $9wGTI.fg)('confluence_forge_content_type_in_content_actions') ? {
                    type: (0, $hIaUw.getContentType)(routeName)
                } : {}
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
            onClose();
        },
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("9gvty"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("4LGZ3"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("73S5H"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("cfR7J"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("6HQrb"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("9I6Dq"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("2IlhC"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("bfAZX"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("eO2rp"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("hLUla"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("2YaVa"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("hzDWs"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("9gvty", function(module, exports) {

let $6bee061e8e45a686$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bee061e8e45a686$var$load("2YffH"),
    $6bee061e8e45a686$var$load("8Kivm"),
    $6bee061e8e45a686$var$load("cf5vC"),
    $6bee061e8e45a686$var$load("8lLr0"),
    $6bee061e8e45a686$var$load("4NNs0"),
    $6bee061e8e45a686$var$load("iQ0Jm"),
    $6bee061e8e45a686$var$load("coJiW"),
    $6bee061e8e45a686$var$load("8TKWI"),
    $6bee061e8e45a686$var$load("RXppq"),
    $6bee061e8e45a686$var$load("h4Nf7"),
    $6bee061e8e45a686$var$load("7f9Fz"),
    $6bee061e8e45a686$var$load("8YSo7"),
    $6bee061e8e45a686$var$load("fqGSw"),
    $6bee061e8e45a686$var$load("2spqH"),
    $6bee061e8e45a686$var$load("gWSdF"),
    $6bee061e8e45a686$var$load("6FuHS"),
    $6bee061e8e45a686$var$load("eyaRC"),
    $6bee061e8e45a686$var$load("g9CVe"),
    $6bee061e8e45a686$var$load("aeEUI"),
    $6bee061e8e45a686$var$load("iXzmH"),
    $6bee061e8e45a686$var$load("65c4i"),
    $6bee061e8e45a686$var$load("6wr18"),
    $6bee061e8e45a686$var$load("kjZZD"),
    $6bee061e8e45a686$var$load("3TTZL"),
    $6bee061e8e45a686$var$load("37ldp"),
    $6bee061e8e45a686$var$load("awqCy"),
    $6bee061e8e45a686$var$load("kHOMt"),
    $6bee061e8e45a686$var$load("hhss7"),
    $6bee061e8e45a686$var$load("4kjaz"),
    $6bee061e8e45a686$var$load("jE6Ik"),
    $6bee061e8e45a686$var$load("dlZSj"),
    $6bee061e8e45a686$var$load("Wowvf"),
    $6bee061e8e45a686$var$load("dS0Pr"),
    $6bee061e8e45a686$var$load("huYla"),
    $6bee061e8e45a686$var$load("76Z06"),
    $6bee061e8e45a686$var$load("47pfq"),
    $6bee061e8e45a686$var$load("crb7b"),
    $6bee061e8e45a686$var$load("let0D"),
    $6bee061e8e45a686$var$load("6EQss"),
    $6bee061e8e45a686$var$load("6M36W"),
    $6bee061e8e45a686$var$load("ffEVr"),
    $6bee061e8e45a686$var$load("kUbUu"),
    $6bee061e8e45a686$var$load("9ftJe"),
    $6bee061e8e45a686$var$load("hUIij"),
    $6bee061e8e45a686$var$load("6Up0b"),
    $6bee061e8e45a686$var$load("lnKog"),
    $6bee061e8e45a686$var$load("7Omhy"),
    $6bee061e8e45a686$var$load("kC80R"),
    $6bee061e8e45a686$var$load("7EorR"),
    $6bee061e8e45a686$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("4LGZ3", function(module, exports) {

let $378ce4dfcab32c4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $378ce4dfcab32c4e$var$load("2YffH"),
    $378ce4dfcab32c4e$var$load("8Kivm"),
    $378ce4dfcab32c4e$var$load("cf5vC"),
    $378ce4dfcab32c4e$var$load("8lLr0"),
    $378ce4dfcab32c4e$var$load("4NNs0"),
    $378ce4dfcab32c4e$var$load("iQ0Jm"),
    $378ce4dfcab32c4e$var$load("coJiW"),
    $378ce4dfcab32c4e$var$load("8TKWI"),
    $378ce4dfcab32c4e$var$load("RXppq"),
    $378ce4dfcab32c4e$var$load("h4Nf7"),
    $378ce4dfcab32c4e$var$load("7f9Fz"),
    $378ce4dfcab32c4e$var$load("8YSo7"),
    $378ce4dfcab32c4e$var$load("fqGSw"),
    $378ce4dfcab32c4e$var$load("2spqH"),
    $378ce4dfcab32c4e$var$load("gWSdF"),
    $378ce4dfcab32c4e$var$load("6FuHS"),
    $378ce4dfcab32c4e$var$load("eyaRC"),
    $378ce4dfcab32c4e$var$load("g9CVe"),
    $378ce4dfcab32c4e$var$load("aeEUI"),
    $378ce4dfcab32c4e$var$load("iXzmH"),
    $378ce4dfcab32c4e$var$load("65c4i"),
    $378ce4dfcab32c4e$var$load("6wr18"),
    $378ce4dfcab32c4e$var$load("kjZZD"),
    $378ce4dfcab32c4e$var$load("3TTZL"),
    $378ce4dfcab32c4e$var$load("37ldp"),
    $378ce4dfcab32c4e$var$load("awqCy"),
    $378ce4dfcab32c4e$var$load("kHOMt"),
    $378ce4dfcab32c4e$var$load("hhss7"),
    $378ce4dfcab32c4e$var$load("4kjaz"),
    $378ce4dfcab32c4e$var$load("jE6Ik"),
    $378ce4dfcab32c4e$var$load("dlZSj"),
    $378ce4dfcab32c4e$var$load("Wowvf"),
    $378ce4dfcab32c4e$var$load("dS0Pr"),
    $378ce4dfcab32c4e$var$load("huYla"),
    $378ce4dfcab32c4e$var$load("76Z06"),
    $378ce4dfcab32c4e$var$load("47pfq"),
    $378ce4dfcab32c4e$var$load("crb7b"),
    $378ce4dfcab32c4e$var$load("let0D"),
    $378ce4dfcab32c4e$var$load("6EQss"),
    $378ce4dfcab32c4e$var$load("6M36W"),
    $378ce4dfcab32c4e$var$load("ffEVr"),
    $378ce4dfcab32c4e$var$load("kUbUu"),
    $378ce4dfcab32c4e$var$load("9ftJe"),
    $378ce4dfcab32c4e$var$load("hUIij"),
    $378ce4dfcab32c4e$var$load("6Up0b"),
    $378ce4dfcab32c4e$var$load("lnKog"),
    $378ce4dfcab32c4e$var$load("7Omhy"),
    $378ce4dfcab32c4e$var$load("kC80R"),
    $378ce4dfcab32c4e$var$load("7EorR"),
    $378ce4dfcab32c4e$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("73S5H", function(module, exports) {

let $5242c58e77ee1553$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5242c58e77ee1553$var$load("2YffH"),
    $5242c58e77ee1553$var$load("8Kivm"),
    $5242c58e77ee1553$var$load("cf5vC"),
    $5242c58e77ee1553$var$load("8lLr0"),
    $5242c58e77ee1553$var$load("4NNs0"),
    $5242c58e77ee1553$var$load("iQ0Jm"),
    $5242c58e77ee1553$var$load("coJiW"),
    $5242c58e77ee1553$var$load("8TKWI"),
    $5242c58e77ee1553$var$load("RXppq"),
    $5242c58e77ee1553$var$load("h4Nf7"),
    $5242c58e77ee1553$var$load("7f9Fz"),
    $5242c58e77ee1553$var$load("8YSo7"),
    $5242c58e77ee1553$var$load("fqGSw"),
    $5242c58e77ee1553$var$load("2spqH"),
    $5242c58e77ee1553$var$load("gWSdF"),
    $5242c58e77ee1553$var$load("6FuHS"),
    $5242c58e77ee1553$var$load("eyaRC"),
    $5242c58e77ee1553$var$load("g9CVe"),
    $5242c58e77ee1553$var$load("aeEUI"),
    $5242c58e77ee1553$var$load("iXzmH"),
    $5242c58e77ee1553$var$load("65c4i"),
    $5242c58e77ee1553$var$load("6wr18"),
    $5242c58e77ee1553$var$load("kjZZD"),
    $5242c58e77ee1553$var$load("3TTZL"),
    $5242c58e77ee1553$var$load("37ldp"),
    $5242c58e77ee1553$var$load("awqCy"),
    $5242c58e77ee1553$var$load("kHOMt"),
    $5242c58e77ee1553$var$load("hhss7"),
    $5242c58e77ee1553$var$load("4kjaz"),
    $5242c58e77ee1553$var$load("jE6Ik"),
    $5242c58e77ee1553$var$load("dlZSj"),
    $5242c58e77ee1553$var$load("Wowvf"),
    $5242c58e77ee1553$var$load("dS0Pr"),
    $5242c58e77ee1553$var$load("huYla"),
    $5242c58e77ee1553$var$load("76Z06"),
    $5242c58e77ee1553$var$load("47pfq"),
    $5242c58e77ee1553$var$load("crb7b"),
    $5242c58e77ee1553$var$load("let0D"),
    $5242c58e77ee1553$var$load("6EQss"),
    $5242c58e77ee1553$var$load("6M36W"),
    $5242c58e77ee1553$var$load("ffEVr"),
    $5242c58e77ee1553$var$load("kUbUu"),
    $5242c58e77ee1553$var$load("9ftJe"),
    $5242c58e77ee1553$var$load("hUIij"),
    $5242c58e77ee1553$var$load("6Up0b"),
    $5242c58e77ee1553$var$load("lnKog"),
    $5242c58e77ee1553$var$load("7Omhy"),
    $5242c58e77ee1553$var$load("kC80R"),
    $5242c58e77ee1553$var$load("7EorR"),
    $5242c58e77ee1553$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("cfR7J", function(module, exports) {

let $8ec018063df249b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ec018063df249b1$var$load("6FuHS"),
    $8ec018063df249b1$var$load("eyaRC"),
    $8ec018063df249b1$var$load("2YffH"),
    $8ec018063df249b1$var$load("cf5vC"),
    $8ec018063df249b1$var$load("8lLr0"),
    $8ec018063df249b1$var$load("4NNs0"),
    $8ec018063df249b1$var$load("8TKWI"),
    $8ec018063df249b1$var$load("RXppq"),
    $8ec018063df249b1$var$load("h4Nf7"),
    $8ec018063df249b1$var$load("7f9Fz"),
    $8ec018063df249b1$var$load("8YSo7"),
    $8ec018063df249b1$var$load("fqGSw"),
    $8ec018063df249b1$var$load("2spqH"),
    $8ec018063df249b1$var$load("gWSdF"),
    $8ec018063df249b1$var$load("g9CVe"),
    $8ec018063df249b1$var$load("aeEUI"),
    $8ec018063df249b1$var$load("iXzmH"),
    $8ec018063df249b1$var$load("65c4i"),
    $8ec018063df249b1$var$load("6wr18"),
    $8ec018063df249b1$var$load("kjZZD"),
    $8ec018063df249b1$var$load("3TTZL"),
    $8ec018063df249b1$var$load("37ldp"),
    $8ec018063df249b1$var$load("awqCy"),
    $8ec018063df249b1$var$load("kHOMt"),
    $8ec018063df249b1$var$load("hhss7"),
    $8ec018063df249b1$var$load("4kjaz"),
    $8ec018063df249b1$var$load("jE6Ik"),
    $8ec018063df249b1$var$load("dlZSj"),
    $8ec018063df249b1$var$load("Wowvf"),
    $8ec018063df249b1$var$load("dS0Pr"),
    $8ec018063df249b1$var$load("huYla"),
    $8ec018063df249b1$var$load("76Z06"),
    $8ec018063df249b1$var$load("47pfq"),
    $8ec018063df249b1$var$load("crb7b"),
    $8ec018063df249b1$var$load("let0D"),
    $8ec018063df249b1$var$load("6EQss"),
    $8ec018063df249b1$var$load("6M36W"),
    $8ec018063df249b1$var$load("hUIij"),
    $8ec018063df249b1$var$load("ffEVr"),
    $8ec018063df249b1$var$load("kUbUu"),
    $8ec018063df249b1$var$load("9ftJe"),
    $8ec018063df249b1$var$load("7Omhy"),
    $8ec018063df249b1$var$load("kC80R"),
    $8ec018063df249b1$var$load("7EorR"),
    $8ec018063df249b1$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("6HQrb", function(module, exports) {

let $4e1f6f308eee372d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e1f6f308eee372d$var$load("6FuHS"),
    $4e1f6f308eee372d$var$load("eyaRC"),
    $4e1f6f308eee372d$var$load("2YffH"),
    $4e1f6f308eee372d$var$load("cf5vC"),
    $4e1f6f308eee372d$var$load("8lLr0"),
    $4e1f6f308eee372d$var$load("4NNs0"),
    $4e1f6f308eee372d$var$load("8TKWI"),
    $4e1f6f308eee372d$var$load("RXppq"),
    $4e1f6f308eee372d$var$load("h4Nf7"),
    $4e1f6f308eee372d$var$load("7f9Fz"),
    $4e1f6f308eee372d$var$load("8YSo7"),
    $4e1f6f308eee372d$var$load("fqGSw"),
    $4e1f6f308eee372d$var$load("2spqH"),
    $4e1f6f308eee372d$var$load("gWSdF"),
    $4e1f6f308eee372d$var$load("g9CVe"),
    $4e1f6f308eee372d$var$load("aeEUI"),
    $4e1f6f308eee372d$var$load("iXzmH"),
    $4e1f6f308eee372d$var$load("65c4i"),
    $4e1f6f308eee372d$var$load("6wr18"),
    $4e1f6f308eee372d$var$load("kjZZD"),
    $4e1f6f308eee372d$var$load("3TTZL"),
    $4e1f6f308eee372d$var$load("37ldp"),
    $4e1f6f308eee372d$var$load("awqCy"),
    $4e1f6f308eee372d$var$load("kHOMt"),
    $4e1f6f308eee372d$var$load("hhss7"),
    $4e1f6f308eee372d$var$load("4kjaz"),
    $4e1f6f308eee372d$var$load("jE6Ik"),
    $4e1f6f308eee372d$var$load("dlZSj"),
    $4e1f6f308eee372d$var$load("Wowvf"),
    $4e1f6f308eee372d$var$load("dS0Pr"),
    $4e1f6f308eee372d$var$load("huYla"),
    $4e1f6f308eee372d$var$load("76Z06"),
    $4e1f6f308eee372d$var$load("47pfq"),
    $4e1f6f308eee372d$var$load("crb7b"),
    $4e1f6f308eee372d$var$load("let0D"),
    $4e1f6f308eee372d$var$load("6EQss"),
    $4e1f6f308eee372d$var$load("6M36W"),
    $4e1f6f308eee372d$var$load("hUIij"),
    $4e1f6f308eee372d$var$load("ffEVr"),
    $4e1f6f308eee372d$var$load("kUbUu"),
    $4e1f6f308eee372d$var$load("9ftJe"),
    $4e1f6f308eee372d$var$load("7Omhy"),
    $4e1f6f308eee372d$var$load("kC80R"),
    $4e1f6f308eee372d$var$load("7EorR"),
    $4e1f6f308eee372d$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("9I6Dq", function(module, exports) {

let $711d5ea90ad0bc6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $711d5ea90ad0bc6b$var$load("6FuHS"),
    $711d5ea90ad0bc6b$var$load("eyaRC"),
    $711d5ea90ad0bc6b$var$load("2YffH"),
    $711d5ea90ad0bc6b$var$load("cf5vC"),
    $711d5ea90ad0bc6b$var$load("8lLr0"),
    $711d5ea90ad0bc6b$var$load("4NNs0"),
    $711d5ea90ad0bc6b$var$load("8TKWI"),
    $711d5ea90ad0bc6b$var$load("RXppq"),
    $711d5ea90ad0bc6b$var$load("h4Nf7"),
    $711d5ea90ad0bc6b$var$load("7f9Fz"),
    $711d5ea90ad0bc6b$var$load("8YSo7"),
    $711d5ea90ad0bc6b$var$load("fqGSw"),
    $711d5ea90ad0bc6b$var$load("2spqH"),
    $711d5ea90ad0bc6b$var$load("gWSdF"),
    $711d5ea90ad0bc6b$var$load("g9CVe"),
    $711d5ea90ad0bc6b$var$load("aeEUI"),
    $711d5ea90ad0bc6b$var$load("iXzmH"),
    $711d5ea90ad0bc6b$var$load("65c4i"),
    $711d5ea90ad0bc6b$var$load("6wr18"),
    $711d5ea90ad0bc6b$var$load("kjZZD"),
    $711d5ea90ad0bc6b$var$load("3TTZL"),
    $711d5ea90ad0bc6b$var$load("37ldp"),
    $711d5ea90ad0bc6b$var$load("awqCy"),
    $711d5ea90ad0bc6b$var$load("kHOMt"),
    $711d5ea90ad0bc6b$var$load("hhss7"),
    $711d5ea90ad0bc6b$var$load("4kjaz"),
    $711d5ea90ad0bc6b$var$load("jE6Ik"),
    $711d5ea90ad0bc6b$var$load("dlZSj"),
    $711d5ea90ad0bc6b$var$load("Wowvf"),
    $711d5ea90ad0bc6b$var$load("dS0Pr"),
    $711d5ea90ad0bc6b$var$load("huYla"),
    $711d5ea90ad0bc6b$var$load("76Z06"),
    $711d5ea90ad0bc6b$var$load("47pfq"),
    $711d5ea90ad0bc6b$var$load("crb7b"),
    $711d5ea90ad0bc6b$var$load("let0D"),
    $711d5ea90ad0bc6b$var$load("6EQss"),
    $711d5ea90ad0bc6b$var$load("6M36W"),
    $711d5ea90ad0bc6b$var$load("hUIij"),
    $711d5ea90ad0bc6b$var$load("ffEVr"),
    $711d5ea90ad0bc6b$var$load("kUbUu"),
    $711d5ea90ad0bc6b$var$load("9ftJe"),
    $711d5ea90ad0bc6b$var$load("7Omhy"),
    $711d5ea90ad0bc6b$var$load("kC80R"),
    $711d5ea90ad0bc6b$var$load("7EorR"),
    $711d5ea90ad0bc6b$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("2IlhC", function(module, exports) {

let $1fa0333a6a974929$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1fa0333a6a974929$var$load("6FuHS"),
    $1fa0333a6a974929$var$load("eyaRC"),
    $1fa0333a6a974929$var$load("2YffH"),
    $1fa0333a6a974929$var$load("cf5vC"),
    $1fa0333a6a974929$var$load("8lLr0"),
    $1fa0333a6a974929$var$load("4NNs0"),
    $1fa0333a6a974929$var$load("8TKWI"),
    $1fa0333a6a974929$var$load("RXppq"),
    $1fa0333a6a974929$var$load("h4Nf7"),
    $1fa0333a6a974929$var$load("7f9Fz"),
    $1fa0333a6a974929$var$load("8YSo7"),
    $1fa0333a6a974929$var$load("fqGSw"),
    $1fa0333a6a974929$var$load("2spqH"),
    $1fa0333a6a974929$var$load("gWSdF"),
    $1fa0333a6a974929$var$load("g9CVe"),
    $1fa0333a6a974929$var$load("aeEUI"),
    $1fa0333a6a974929$var$load("iXzmH"),
    $1fa0333a6a974929$var$load("65c4i"),
    $1fa0333a6a974929$var$load("6wr18"),
    $1fa0333a6a974929$var$load("kjZZD"),
    $1fa0333a6a974929$var$load("3TTZL"),
    $1fa0333a6a974929$var$load("37ldp"),
    $1fa0333a6a974929$var$load("awqCy"),
    $1fa0333a6a974929$var$load("kHOMt"),
    $1fa0333a6a974929$var$load("hhss7"),
    $1fa0333a6a974929$var$load("4kjaz"),
    $1fa0333a6a974929$var$load("jE6Ik"),
    $1fa0333a6a974929$var$load("dlZSj"),
    $1fa0333a6a974929$var$load("Wowvf"),
    $1fa0333a6a974929$var$load("dS0Pr"),
    $1fa0333a6a974929$var$load("huYla"),
    $1fa0333a6a974929$var$load("76Z06"),
    $1fa0333a6a974929$var$load("47pfq"),
    $1fa0333a6a974929$var$load("crb7b"),
    $1fa0333a6a974929$var$load("let0D"),
    $1fa0333a6a974929$var$load("6EQss"),
    $1fa0333a6a974929$var$load("6M36W"),
    $1fa0333a6a974929$var$load("ffEVr"),
    $1fa0333a6a974929$var$load("kUbUu"),
    $1fa0333a6a974929$var$load("9ftJe"),
    $1fa0333a6a974929$var$load("hUIij"),
    $1fa0333a6a974929$var$load("6Up0b"),
    $1fa0333a6a974929$var$load("lnKog"),
    $1fa0333a6a974929$var$load("7Omhy"),
    $1fa0333a6a974929$var$load("kC80R"),
    $1fa0333a6a974929$var$load("7EorR"),
    $1fa0333a6a974929$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("bfAZX", function(module, exports) {

let $830dcb876095fb80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $830dcb876095fb80$var$load("2YffH"),
    $830dcb876095fb80$var$load("cf5vC"),
    $830dcb876095fb80$var$load("8lLr0"),
    $830dcb876095fb80$var$load("4NNs0"),
    $830dcb876095fb80$var$load("coJiW"),
    $830dcb876095fb80$var$load("8TKWI"),
    $830dcb876095fb80$var$load("RXppq"),
    $830dcb876095fb80$var$load("h4Nf7"),
    $830dcb876095fb80$var$load("7f9Fz"),
    $830dcb876095fb80$var$load("8YSo7"),
    $830dcb876095fb80$var$load("fqGSw"),
    $830dcb876095fb80$var$load("2spqH"),
    $830dcb876095fb80$var$load("gWSdF"),
    $830dcb876095fb80$var$load("6FuHS"),
    $830dcb876095fb80$var$load("eyaRC"),
    $830dcb876095fb80$var$load("g9CVe"),
    $830dcb876095fb80$var$load("aeEUI"),
    $830dcb876095fb80$var$load("iXzmH"),
    $830dcb876095fb80$var$load("65c4i"),
    $830dcb876095fb80$var$load("6wr18"),
    $830dcb876095fb80$var$load("kjZZD"),
    $830dcb876095fb80$var$load("3TTZL"),
    $830dcb876095fb80$var$load("37ldp"),
    $830dcb876095fb80$var$load("dTsOE"),
    $830dcb876095fb80$var$load("awqCy"),
    $830dcb876095fb80$var$load("kHOMt"),
    $830dcb876095fb80$var$load("hhss7"),
    $830dcb876095fb80$var$load("4kjaz"),
    $830dcb876095fb80$var$load("jE6Ik"),
    $830dcb876095fb80$var$load("dlZSj"),
    $830dcb876095fb80$var$load("Wowvf"),
    $830dcb876095fb80$var$load("dS0Pr"),
    $830dcb876095fb80$var$load("huYla"),
    $830dcb876095fb80$var$load("76Z06"),
    $830dcb876095fb80$var$load("47pfq"),
    $830dcb876095fb80$var$load("crb7b"),
    $830dcb876095fb80$var$load("let0D"),
    $830dcb876095fb80$var$load("6EQss"),
    $830dcb876095fb80$var$load("6M36W"),
    $830dcb876095fb80$var$load("ffEVr"),
    $830dcb876095fb80$var$load("kUbUu"),
    $830dcb876095fb80$var$load("9ftJe"),
    $830dcb876095fb80$var$load("hUIij"),
    $830dcb876095fb80$var$load("6Up0b"),
    $830dcb876095fb80$var$load("lnKog"),
    $830dcb876095fb80$var$load("7Omhy"),
    $830dcb876095fb80$var$load("kC80R"),
    $830dcb876095fb80$var$load("7EorR"),
    $830dcb876095fb80$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("eO2rp", function(module, exports) {

let $ac77a0f0620e9581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac77a0f0620e9581$var$load("2YffH"),
    $ac77a0f0620e9581$var$load("cf5vC"),
    $ac77a0f0620e9581$var$load("8lLr0"),
    $ac77a0f0620e9581$var$load("4NNs0"),
    $ac77a0f0620e9581$var$load("coJiW"),
    $ac77a0f0620e9581$var$load("8TKWI"),
    $ac77a0f0620e9581$var$load("RXppq"),
    $ac77a0f0620e9581$var$load("h4Nf7"),
    $ac77a0f0620e9581$var$load("7f9Fz"),
    $ac77a0f0620e9581$var$load("8YSo7"),
    $ac77a0f0620e9581$var$load("fqGSw"),
    $ac77a0f0620e9581$var$load("2spqH"),
    $ac77a0f0620e9581$var$load("gWSdF"),
    $ac77a0f0620e9581$var$load("6FuHS"),
    $ac77a0f0620e9581$var$load("eyaRC"),
    $ac77a0f0620e9581$var$load("g9CVe"),
    $ac77a0f0620e9581$var$load("aeEUI"),
    $ac77a0f0620e9581$var$load("iXzmH"),
    $ac77a0f0620e9581$var$load("65c4i"),
    $ac77a0f0620e9581$var$load("6wr18"),
    $ac77a0f0620e9581$var$load("kjZZD"),
    $ac77a0f0620e9581$var$load("3TTZL"),
    $ac77a0f0620e9581$var$load("37ldp"),
    $ac77a0f0620e9581$var$load("dTsOE"),
    $ac77a0f0620e9581$var$load("awqCy"),
    $ac77a0f0620e9581$var$load("kHOMt"),
    $ac77a0f0620e9581$var$load("hhss7"),
    $ac77a0f0620e9581$var$load("4kjaz"),
    $ac77a0f0620e9581$var$load("jE6Ik"),
    $ac77a0f0620e9581$var$load("dlZSj"),
    $ac77a0f0620e9581$var$load("Wowvf"),
    $ac77a0f0620e9581$var$load("dS0Pr"),
    $ac77a0f0620e9581$var$load("huYla"),
    $ac77a0f0620e9581$var$load("76Z06"),
    $ac77a0f0620e9581$var$load("47pfq"),
    $ac77a0f0620e9581$var$load("crb7b"),
    $ac77a0f0620e9581$var$load("let0D"),
    $ac77a0f0620e9581$var$load("6EQss"),
    $ac77a0f0620e9581$var$load("6M36W"),
    $ac77a0f0620e9581$var$load("ffEVr"),
    $ac77a0f0620e9581$var$load("kUbUu"),
    $ac77a0f0620e9581$var$load("9ftJe"),
    $ac77a0f0620e9581$var$load("hUIij"),
    $ac77a0f0620e9581$var$load("6Up0b"),
    $ac77a0f0620e9581$var$load("lnKog"),
    $ac77a0f0620e9581$var$load("7Omhy"),
    $ac77a0f0620e9581$var$load("kC80R"),
    $ac77a0f0620e9581$var$load("7EorR"),
    $ac77a0f0620e9581$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("hLUla", function(module, exports) {

let $cf0287818820f2db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf0287818820f2db$var$load("6FuHS"),
    $cf0287818820f2db$var$load("eyaRC"),
    $cf0287818820f2db$var$load("2YffH"),
    $cf0287818820f2db$var$load("cf5vC"),
    $cf0287818820f2db$var$load("8lLr0"),
    $cf0287818820f2db$var$load("4NNs0"),
    $cf0287818820f2db$var$load("8TKWI"),
    $cf0287818820f2db$var$load("RXppq"),
    $cf0287818820f2db$var$load("h4Nf7"),
    $cf0287818820f2db$var$load("7f9Fz"),
    $cf0287818820f2db$var$load("8YSo7"),
    $cf0287818820f2db$var$load("fqGSw"),
    $cf0287818820f2db$var$load("2spqH"),
    $cf0287818820f2db$var$load("gWSdF"),
    $cf0287818820f2db$var$load("g9CVe"),
    $cf0287818820f2db$var$load("aeEUI"),
    $cf0287818820f2db$var$load("iXzmH"),
    $cf0287818820f2db$var$load("65c4i"),
    $cf0287818820f2db$var$load("6wr18"),
    $cf0287818820f2db$var$load("kjZZD"),
    $cf0287818820f2db$var$load("3TTZL"),
    $cf0287818820f2db$var$load("37ldp"),
    $cf0287818820f2db$var$load("awqCy"),
    $cf0287818820f2db$var$load("kHOMt"),
    $cf0287818820f2db$var$load("hhss7"),
    $cf0287818820f2db$var$load("4kjaz"),
    $cf0287818820f2db$var$load("jE6Ik"),
    $cf0287818820f2db$var$load("dlZSj"),
    $cf0287818820f2db$var$load("Wowvf"),
    $cf0287818820f2db$var$load("dS0Pr"),
    $cf0287818820f2db$var$load("huYla"),
    $cf0287818820f2db$var$load("76Z06"),
    $cf0287818820f2db$var$load("47pfq"),
    $cf0287818820f2db$var$load("crb7b"),
    $cf0287818820f2db$var$load("let0D"),
    $cf0287818820f2db$var$load("6EQss"),
    $cf0287818820f2db$var$load("6M36W"),
    $cf0287818820f2db$var$load("hUIij"),
    $cf0287818820f2db$var$load("ffEVr"),
    $cf0287818820f2db$var$load("kUbUu"),
    $cf0287818820f2db$var$load("9ftJe"),
    $cf0287818820f2db$var$load("7Omhy"),
    $cf0287818820f2db$var$load("kC80R"),
    $cf0287818820f2db$var$load("7EorR"),
    $cf0287818820f2db$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("2YaVa", function(module, exports) {

let $2299a80b7274df51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2299a80b7274df51$var$load("6FuHS"),
    $2299a80b7274df51$var$load("eyaRC"),
    $2299a80b7274df51$var$load("2YffH"),
    $2299a80b7274df51$var$load("cf5vC"),
    $2299a80b7274df51$var$load("8lLr0"),
    $2299a80b7274df51$var$load("4NNs0"),
    $2299a80b7274df51$var$load("8TKWI"),
    $2299a80b7274df51$var$load("RXppq"),
    $2299a80b7274df51$var$load("h4Nf7"),
    $2299a80b7274df51$var$load("7f9Fz"),
    $2299a80b7274df51$var$load("8YSo7"),
    $2299a80b7274df51$var$load("fqGSw"),
    $2299a80b7274df51$var$load("2spqH"),
    $2299a80b7274df51$var$load("gWSdF"),
    $2299a80b7274df51$var$load("g9CVe"),
    $2299a80b7274df51$var$load("aeEUI"),
    $2299a80b7274df51$var$load("iXzmH"),
    $2299a80b7274df51$var$load("65c4i"),
    $2299a80b7274df51$var$load("6wr18"),
    $2299a80b7274df51$var$load("kjZZD"),
    $2299a80b7274df51$var$load("3TTZL"),
    $2299a80b7274df51$var$load("37ldp"),
    $2299a80b7274df51$var$load("awqCy"),
    $2299a80b7274df51$var$load("kHOMt"),
    $2299a80b7274df51$var$load("hhss7"),
    $2299a80b7274df51$var$load("4kjaz"),
    $2299a80b7274df51$var$load("jE6Ik"),
    $2299a80b7274df51$var$load("dlZSj"),
    $2299a80b7274df51$var$load("Wowvf"),
    $2299a80b7274df51$var$load("dS0Pr"),
    $2299a80b7274df51$var$load("huYla"),
    $2299a80b7274df51$var$load("76Z06"),
    $2299a80b7274df51$var$load("47pfq"),
    $2299a80b7274df51$var$load("crb7b"),
    $2299a80b7274df51$var$load("let0D"),
    $2299a80b7274df51$var$load("6EQss"),
    $2299a80b7274df51$var$load("6M36W"),
    $2299a80b7274df51$var$load("ffEVr"),
    $2299a80b7274df51$var$load("kUbUu"),
    $2299a80b7274df51$var$load("9ftJe"),
    $2299a80b7274df51$var$load("hUIij"),
    $2299a80b7274df51$var$load("6Up0b"),
    $2299a80b7274df51$var$load("lnKog"),
    $2299a80b7274df51$var$load("7Omhy"),
    $2299a80b7274df51$var$load("kC80R"),
    $2299a80b7274df51$var$load("7EorR"),
    $2299a80b7274df51$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("hzDWs", function(module, exports) {

let $ccb4b0304ec714ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ccb4b0304ec714ff$var$load("6FuHS"),
    $ccb4b0304ec714ff$var$load("eyaRC"),
    $ccb4b0304ec714ff$var$load("2YffH"),
    $ccb4b0304ec714ff$var$load("cf5vC"),
    $ccb4b0304ec714ff$var$load("8lLr0"),
    $ccb4b0304ec714ff$var$load("4NNs0"),
    $ccb4b0304ec714ff$var$load("8TKWI"),
    $ccb4b0304ec714ff$var$load("RXppq"),
    $ccb4b0304ec714ff$var$load("h4Nf7"),
    $ccb4b0304ec714ff$var$load("7f9Fz"),
    $ccb4b0304ec714ff$var$load("8YSo7"),
    $ccb4b0304ec714ff$var$load("fqGSw"),
    $ccb4b0304ec714ff$var$load("2spqH"),
    $ccb4b0304ec714ff$var$load("gWSdF"),
    $ccb4b0304ec714ff$var$load("g9CVe"),
    $ccb4b0304ec714ff$var$load("aeEUI"),
    $ccb4b0304ec714ff$var$load("iXzmH"),
    $ccb4b0304ec714ff$var$load("65c4i"),
    $ccb4b0304ec714ff$var$load("6wr18"),
    $ccb4b0304ec714ff$var$load("kjZZD"),
    $ccb4b0304ec714ff$var$load("3TTZL"),
    $ccb4b0304ec714ff$var$load("37ldp"),
    $ccb4b0304ec714ff$var$load("awqCy"),
    $ccb4b0304ec714ff$var$load("kHOMt"),
    $ccb4b0304ec714ff$var$load("hhss7"),
    $ccb4b0304ec714ff$var$load("4kjaz"),
    $ccb4b0304ec714ff$var$load("jE6Ik"),
    $ccb4b0304ec714ff$var$load("dlZSj"),
    $ccb4b0304ec714ff$var$load("Wowvf"),
    $ccb4b0304ec714ff$var$load("dS0Pr"),
    $ccb4b0304ec714ff$var$load("huYla"),
    $ccb4b0304ec714ff$var$load("76Z06"),
    $ccb4b0304ec714ff$var$load("47pfq"),
    $ccb4b0304ec714ff$var$load("crb7b"),
    $ccb4b0304ec714ff$var$load("let0D"),
    $ccb4b0304ec714ff$var$load("6EQss"),
    $ccb4b0304ec714ff$var$load("6M36W"),
    $ccb4b0304ec714ff$var$load("ffEVr"),
    $ccb4b0304ec714ff$var$load("kUbUu"),
    $ccb4b0304ec714ff$var$load("9ftJe"),
    $ccb4b0304ec714ff$var$load("hUIij"),
    $ccb4b0304ec714ff$var$load("6Up0b"),
    $ccb4b0304ec714ff$var$load("lnKog"),
    $ccb4b0304ec714ff$var$load("7Omhy"),
    $ccb4b0304ec714ff$var$load("kC80R"),
    $ccb4b0304ec714ff$var$load("7EorR"),
    $ccb4b0304ec714ff$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("dVFAI"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("dVFAI", function(module, exports) {

let $a240dc5be70b389e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a240dc5be70b389e$var$load("hUIij"),
    $a240dc5be70b389e$var$load("6Up0b"),
    $a240dc5be70b389e$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.58235edb.js.map
